<template>
    <div v-wechat-title="title">
        <crud-facecade
            ref="recovery-list"
            :url="url"
            :columns="columnList"
            :buttons="buttons"
            :tableHeight="screenHeight - 205"
            :addButton="{ enabled: false }"
            :updateButton="{ enabled: false }"
            :columnConfig="true"
            :searchLocal="false"
            @print="print"
            @loadRevDoc="loadRevDoc"
            @RecoveryBedOutToBedIn="RecoveryBedOutToBedIn"
        >
            <slot slot="filter">
                <el-col :md="8" :xl="8" title="出室时间">
                    <item-input :type="RecoveryQueryRule=='0'?'daterange':'datetimerange'" v-model="rdate" :noPadding="true"></item-input>
                </el-col>
            </slot>
            <slot slot="filter-after">
                <el-button type="primary" size="mini" @click="refreshList" title="查询">查询<i class="el-icon--right"></i></el-button>
                <el-button type="primary" size="mini" @click="printdoc">打印<i class="el-icon--right"></i></el-button>
                <el-button type="primary" size="mini" @click="exportExcel">导出<i class="el-icon--right"></i></el-button>
            </slot>
            <template slot="patient_name" slot-scope="{ row }">
                {{ row.patient_name }}
                <span class="circle fg-red borderd" v-if="row.is_reoperation">再</span>
            </template>
        </crud-facecade>
        <el-pagination
            class="align-left"
            background
            layout="total, sizes, prev, pager, next, jumper"
            @size-change="refreshList"
            @current-change="refreshList"
            :page-sizes="[10, 20, 50, 100, 200]"
            :current-page.sync="currentPage"
            :page-size.sync="pageSize"
            :total="total"
        >
        </el-pagination>
        <pdf-frame :base64="base64" :visible.sync="pdfvisible" title="苏醒记录单"></pdf-frame>
    </div>
</template>
<script>
import printJs from 'print-js'
import { mapGetters } from 'vuex'
export default {
    name: `RecoveryRecord`,
    props: {

    },
    data() {
        return {
            title: `复苏查询`,
            url: { area: `Recovery`,
                baseURL: ``,
                get: paras => {
                    return new Promise((resolve, reject) => {
                        let that = this
                        let ward = this.active_ward && this.active_ward.value && this.active_ward.value.replace(`rw_`, ``) || ` `
                        paras.begin = this.rdate[0]
                        paras.end = this.$moment(this.rdate[1]).format(`YYYY/MM/DD HH:mm:ss`)
                        paras.dic_recovery_ward_id = ward
                        let req = that.myaxios.postpagination(`/api/Postoperative/Recovery/RecoveredsPage?pageIndex=${this.currentPage}&pageSize=${this.pageSize}`,
                            paras
                        )
                        // let req = that.myaxios.get(`/api/Postoperative/Recovery/Recovereds`, { begin: this.rdate[0], end: this.$moment(this.rdate[1]).format(`YYYY/MM/DD HH:mm:ss`) })
                        req.then(res => {
                            console.log(res)
                            this.total = res.count
                            var data = res.data
                            let r = data.map(d => {
                                d.longtimes = that.$moment(d.out_recovery_room).diff(d.in_recovery_room, `minute`)
                                // reload的时候把动态列字段放到obj对象里面
                                this.$surgeryInfoExtraParamUtil.SetSurgeryInfoObj(this.extendColumnList, d, d)
                                return d
                            })
                            console.log(r)
                            resolve(r)
                        }).catch(e => reject(e))
                    })
                } },
            rdate: [this.$moment().add(-7, `days`).format(`YYYY/MM/DD HH:mm:ss`), this.$moment().add(1, `days`).format(`YYYY/MM/DD HH:mm:ss`)],
            buttons: [{
                class: `is-plain is-circle`,
                label: ``,
                icon: `el-icon-printer`,
                type: `primary`,
                emit: `print`,
                permission: `default`
            }, {
                class: `is-plain is-circle`,
                label: ``,
                icon: `el-icon-document`,
                type: `primary`,
                emit: `loadRevDoc`,
                permission: `default`
            }, {
                class: `is-plain is-circle`,
                label: `退`,
                icon: ``,
                type: `primary`,
                emit: `RecoveryBedOutToBedIn`,
                permission: `surgery_list:resuscitation`
            }],
            base64: ``,
            pdfvisible: false,
            currentPage: 1,
            pageSize: 50,
            total: 0,
            RecoveryQueryRule: this.$root.RecoveryQueryRule,
            IsCanPrintAfterArchived: this.$root.IsCanPrintAfterArchived
        }
    },
    created() {
        this.setDateRange()
    },
    computed: {
        ...mapGetters([`active_ward`, `screenHeight`,
            `otherSettingColumn`,
            `extendColumnList`]),
        columnList() {
            let list = [{
                type: `string`,
                prop: `id`,
                label: `编号`,
                isListable: false,
                isKey: true
            }, {
                type: `string`,
                prop: `dic_recovery_bed`,
                label: `复苏床位`,
                width: `120`,
                isListable: true
            }, {
                type: `string`,
                prop: `dic_operating_room`,
                label: `手术间`,
                width: `120`,
                isListable: true
            }, {
                type: `string`,
                prop: `bed_no`,
                label: this.T(`recovery_query.bed_no`),
                width: `120`,
                isListable: true
            }, {
                type: `custom`,
                prop: `patient_name`,
                label: `姓名`,
                width: `200`,
                isListable: true
            }, {
                type: `string`,
                prop: `patient_name`,
                label: `姓名`,
                width: `200`,
                searchable: true
            }, {
                type: `string`,
                prop: `age`,
                label: `年龄`,
                width: `80`,
                isListable: true,
                searchable: true
            }, {
                type: `string`,
                prop: `visit_no`,
                label: this.T(`recovery_query.visit_no`),
                width: `60`,
                isListable: true,
                searchable: true
            }, {
                type: `string`,
                prop: `his_id`,
                label: this.T(`his_id`),
                width: `120`,
                isListable: true
            },
            {
                type: `string`,
                prop: `sex`,
                label: `性别`,
                width: `40`,
                isListable: true
                // searchable: true
            }, {
                type: `string`,
                prop: `surgeries`,
                label: `手术名称`,
                isListable: true,
                searchable: true
            }, {
                type: `string`,
                prop: `surgeon`,
                label: this.T(`anesthesia_surgeries.plan_surgeon`),
                width: `140`,
                isListable: true,
                searchable: true
            }, {
                type: `string`,
                prop: `anaes_methods`,
                label: `麻醉方式`,
                width: `140`,
                isListable: true,
                searchable: true
            }, {
                type: `string`,
                prop: `anes_doctor`,
                label: this.T(`anesthesia_surgeries.plan_anes_doctor`),
                width: `140`,
                isListable: true,
                searchable: true
            }, {
                type: `datetime`,
                prop: `in_recovery_room`,
                label: `进苏醒室时间`,
                width: `140`,
                isListable: true
            }, {
                type: `datetime`,
                prop: `out_recovery_room`,
                label: `出苏醒室时间`,
                width: `140`,
                isListable: true
            }, {
                type: `string`,
                prop: `longtimes`,
                label: `复苏时长(分钟)`,
                width: `140`,
                isListable: true
            }
            ]
            // 显示扩展动态列
            list = this.$surgeryInfoExtraParamUtil.SetExtraColumnList(this.extendColumnList, list)
            return list
        }
    },
    mounted() {

    },
    methods: {
        refreshList() {
            this.$refs[`recovery-list`].ReloadListData()
        },
        printdoc() {
            let from = this.rdate[0]
            let to = this.rdate[1]
            if (from == `` || to == ``) {
                this.$message.error(`开始/结束时间不允许为空！`)
                return
            }
            let ward = this.active_ward && this.active_ward.value && this.active_ward.value.replace(`rw_`, ``) || ``
            if (ward == `` || ward.indexOf(`ow_`) > -1) {
                this.$message.error(`请选择复苏室操作打印！`)
                return
            }
            // 打印时间区间内数据
            this.$store.dispatch(`PRINT_PDF`, {
                host: this.$root.DOCSERVICE_BASE,
                params: Object.assign(
                    {
                        docid: this.$root.DOCUMENT.FSLB001,
                        id1: ``,
                        objId: ward,
                        from: this.$moment(from).format(`YYYYMMDDHHmm`),
                        to: this.$moment(to).format(`YYYYMMDDHHmm`)
                    },
                    { isShowSendPrintMessage: this.$root.isShowSendPrintMessage }
                )
            })
            console.log(from, to)
        },
        exportExcel() {
            let that = this
            let paras = this.$refs[`recovery-list`] && this.$refs[`recovery-list`].searchColumnData
            paras.keyword = this.$refs[`recovery-list`] && this.$refs[`recovery-list`].searchValue
            let ward = this.active_ward && this.active_ward.value && this.active_ward.value.replace(`rw_`, ``) || ` `
            paras.begin = this.rdate[0]
            paras.end = this.$moment(this.rdate[1]).format(`YYYY/MM/DD HH:mm:ss`)
            paras.dic_recovery_ward_id = ward
            let req = that.myaxios.post(`/api/Postoperative/Recovery/GetRecoveredsForExport`,
                paras
            )
            req.then(data => {
                if (data.length <= 0) {
                    this.$message.warning(`暂无导出数据`)
                    return
                }
                that.myaxios.export_excel(data, `复苏信息.xls`)
            }).catch(e => {
                that.$message.error(`导出数据出错`)
            })
        },
        print({ row }) {
            let reqConfig = this.myaxios.get(`/api/AcisSystem/RecordConfig/SurgeryInfoMapRecord?surgeryInfoId=${row.id}&recordType=2`)
            reqConfig.then(data => {
                console.log(data)
                if (!data.is_archived && this.IsCanPrintAfterArchived && this.IsCanPrintAfterArchived == `1`) {
                    this.$message(`复苏单需要先归档后才能打印`, `info`)
                    return false
                }
                let req = this.myaxios.post(`/api/Operation/Home/ExportPdf?surgeryInfoId=${row.id}&recordType=2`)
                req.then(data => {
                    printJs({ printable: data, type: `pdf`, base64: true })
                }).catch(e => console.log(e))
            }).catch(e => console.log(e))
        },
        loadRevDoc({ row }) {
            let r = typeof winformMsg
            if (r != `undefined`) {
                var cefJson = {
                    action: `openRev`,
                    id: row.id
                }
                winformMsg.acceptMessage(cefJson)
            } else {
                let req = this.myaxios.post(`/api/Operation/Home/ExportPdf?surgeryInfoId=${row.surgeryInfoId || row.id}&recordType=2`)
                req.then(data => {
                    this.pdfvisible = true
                    this.base64 = data
                }).catch(e => console.log(e))
            }
        },
        RecoveryBedOutToBedIn({ row }) {
            let that = this
            that.$confirm(`确定撤回到苏醒中?`, `提示`, {
                confirmButtonText: `确定`,
                cancelButtonText: `取消`,
                type: `warning`,
                closeOnClickModal: false
            }).then(() => {
                let req = this.myaxios.put(`/api/Postoperative/Recovery/RecoveryBedOutToBedIn?surgeryInfoId=${row.id}`)
                req.then(data => {
                    this.$refs[`recovery-list`].ReloadListData()
                }).catch(e => {
                })
            })
        },
        // added by xiaorui，ACIS-1434,设置自定义时间段
        setDateRange() {
            let setconfig = this.$root.RecoverySelectDaysSetting
            let startDays = 0
            let endDays = 0
            if (setconfig) {
                let config = JSON.parse(setconfig)
                let fDays = parseInt(config.查询当前时间前多少天)
                let eDays = parseInt(config.查询当前时间后多少天)

                if (fDays && fDays > 0) {
                    startDays = fDays
                }

                if (eDays && eDays > 0) {
                    endDays = eDays
                }
            }

            let start = this.$moment().add(-startDays, `days`).format(`YYYY/MM/DD 00:00:00`)
            let end = this.$moment().add(endDays, `days`).format(`YYYY/MM/DD 23:59:59`)
            this.rdate = [start, end]
        }
    },
    watch: {
        rdate: function() {
            // this.$refs[`recovery-list`].ReloadListData()
        },
        active_ward: function() {
            this.$refs[`recovery-list`].ReloadListData()
        }
    }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Recovery/Query.vue